import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'
import { Metrics, Fonts, Colors } from '../../Themes'
import Modal from './index'
import TileWithIcon from '../../components/TileWithIcon'
import CheckCircle from '../../svg-icons/CheckCircle'
import Button from '../../components/Button'

const CustomButton = styled(Button)`
  margin-top: ${Metrics.margins.base};
`

const Header = styled.div`
  ${Fonts.style.Header};
  color: ${Colors.primary};
`

class SuccesModal extends Component {
  shouldComponentUpdate (nextProps) {
    const { visible } = this.props
    return visible !== nextProps.visible
  }

  render () {
    const { visible, closeAction, header, message, backAction } = this.props
    return (
      <Modal
        header={<Header>{header}</Header>}
        visible={visible}
        closeAction={closeAction}
        backAction={backAction}>
        <div>
          <TileWithIcon text={message} icon={<CheckCircle />} />
        </div>
        <CustomButton onClick={closeAction} label='OK' />
      </Modal>
    )
  }
}

SuccesModal.propTypes = {
  visible: PropTypes.bool,
  message: PropTypes.node,
  closeAction: PropTypes.func,
  backAction: PropTypes.func,
  header: PropTypes.node
}

export default SuccesModal



// WEBPACK FOOTER //
// ./src/components/Modal/SuccessModal.js